// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AdminGames_buttons__3y1J8","jsontextarea":"AdminGames_jsontextarea__TyGCF"};